import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { UserMessageList } from '../user-message-list/user-message-list';
import { BlockedUsers } from '../blocked-users/blocked-users';

// short labels, so the three tabs fit one row on a phone
const TABS = [
    { name: 'received_messages', label: 'tab_received' },
    { name: 'sent_messages', label: 'tab_sent' },
    { name: 'blocked_users', label: 'tab_blocked' },
];

export const UserInbox = () => {
    const { t } = useTranslation(["message"]);
    const [tab, setTab] = useState(TABS[0].name);

    return (
        <section className='hs hs-panel-page'>
            <div className='hs-panel-tabs fill' role='tablist'>
                {TABS.map(({ name, label }) => (
                    <button key={name} role='tab' aria-selected={name === tab} className={name === tab ? 'on' : ''}
                        onClick={() => setTab(name)}>{t(label)}</button>
                ))}
            </div>
            {tab === 'blocked_users' ? <BlockedUsers /> : <UserMessageList type={tab} key={tab} />}
        </section>
    );
};
